<template>
  <div class="message-window">
    <div class="mx-2">
      <div
        v-if="extraAttributes != null && extraAttributes.visibility === 'sales'"
        class="mr-3 instructions"
      >
        Merci de faire un compte rendu a chaque fois que vous faites de
        l'activité sur le client, au minimum tous les 2 jours : avancée du
        projet, nombre de propositions, visites éventuelles, toutes questions du
        client...
      </div>
      <div
        v-for="com in orderedComments"
        :key="com._id"
        :class="{
          'ml-3': com.owner === 'user',
          'mr-3': com.owner === 'hil',
          'mr-2': true,
          'pb-2': true
        }"
      >
        <!-- Prettier rule: https://prettier.io/blog/2018/11/07/1.15.0.html#whitespace-sensitive-formatting -->
        <!-- display: inline -->
        <div
          class="message-content px-2 py-2 mt-3"
          :class="{ [`comm-${com.owner}`]: true }"
          >{{ com.content }}
        </div>
        <div class="message-infos d-flex justify-end pt-1 pr-2">
          <a @click="confirmDeleteComment(com._id)" style="color: red"
            >Supprimer</a
          >
          - {{ com.author }} &mdash; {{ com.createdAt | fullDate }}
        </div>
      </div>
    </div>
    <v-layout row align-baseline justify-center class="pl-3 pr-2">
      <v-flex>
        <v-textarea label="Message" rows="3" v-model="message"></v-textarea>
      </v-flex>
      <v-flex xs1>
        <v-icon style="cursor: pointer" @click="sendMessage">send</v-icon>
      </v-flex>
    </v-layout>

    <v-snackbar v-model="showError"> Une erreur a eu lieu </v-snackbar>
  </div>
</template>

<script>
import { fetchHil2 } from "../../utils";
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["filter", "targetId", "extraAttributes"],
  data() {
    return {
      message: "",
      showError: false
    };
  },
  async mounted() {
    this.reload();
  },
  methods: {
    ...mapActions("notifications", ["markNotifsAsRead"]),
    ...mapActions("comments", ["fetchComments", "pushComment"]),

    async reload() {
      await this.fetchComments({
        targetId: this.targetId,
        extraAttributes: this.extraAttributes,
        filter: this.filter
      });
      await this.markNotifsAsRead({
        projectId: this.$route.params.id
      });
      this.goDown();
    },

    async sendMessage() {
      if (this.message == null) {
        return;
      }
      try {
        await this.pushComment({
          content: this.message
        });
        this.goDown();
        this.message = "";
      } catch (e) {
        console.error(e);
        this.showError = true;
      }
    },
    goDown() {
      let container = this.$el;
      container.scrollTop = container.scrollHeight;
    },
    async confirmDeleteComment(id) {
      if (confirm("Etes vous sûr de vouloir supprimer ce commentaire ?")) {
        await fetchHil2("DELETE", `/comments/${id}`);
        this.reload();
      }
    }
  },
  computed: {
    ...mapGetters("comments", ["orderedComments"])
  }
};
</script>

<style>
.message-content {
  font-size: 14px;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  padding: 4px;
  border-radius: 5px;
  background: #999;
}
.message-infos {
  padding-left: 8px;
  font-size: 10px;
  font-style: italic;
}
.instructions {
  color: grey;
  margin-top: 8px;
  font-size: 0.9rem;
}
.comm-hil {
  background: linear-gradient(to bottom, hsl(165, 28%, 65%), #60a694 60px);
  color: white;
}
.comm-user {
  background: linear-gradient(
    to bottom,
    hsl(11, 100%, 68%),
    hsl(11, 100%, 58%) 60px
  );
  color: white;
}

.message-window {
  height: calc(100vh - 170px);
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
